import axios from 'axios';

const addressApi = axios.create({
  baseURL: process.env.REACT_APP_ADDRESS_API_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
});

export default addressApi;